module.exports = __webpack_public_path__ + "img/a13.ab79100c.png";